<template>
  <div>
    <tabs
      :niveau="2"
      :links="tabList"
      :current-tab="tab"
      @changeView="tab = $event"
      mode="emitter"
      :level="2"
      class="has-background-light is-border-bottom"></tabs>
    <table
      class="table is-hoverable is-striped-v is-fullwidth is-first-fixed-xsmall is-marginless-bottom"
      v-if="optionsToDisplay && optionsToDisplay.length">
      <thead>
        <tr class="is-size-6">
          <th>Statut</th>
          <th>Lot</th>
          <th>Programme</th>
          <th v-if="displayCompany">
            Société
          </th>
          <th v-if="displaySeller">
            Vendeur
          </th>
          <th v-if="displayContact">
            Contact
          </th>
          <th>Date de création</th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="is-border-top is-size-6"
          v-for="(option, index) in optionsToDisplay"
          :key="'tr' + index">
          <td class="has-text-centered">
            <span
              class="dot tooltip"
              :class="option.status | optionsDotClass"
              :data-tooltip="optionStatus[option.status].label"></span>
          </td>
          <td class="is-cell-hoverable">
            <router-link
              v-if="option.lot"
              :to="{name: 'LotVue', params: {id: option.lot.pk}}">
              {{ option.lot.ref }}
            </router-link>
            <span v-else>--</span>
          </td>
          <td class="is-cell-hoverable">
            <router-link
              v-if="option.program"
              :to="{name: 'ProgramVue', params: {id: option.program.pk}}">
              {{ option.program.name }}
            </router-link>
            <span v-else>--</span>
          </td>
          <td v-if="displayCompany">
            <router-link :to="{name: 'CompanyVue', params: {id: option.account.pk}}">
              {{ option.account.name }}
            </router-link>
          <!-- <router-link v-if="option.account.pk !== currentUser.account.pk" :to="{name: 'CompanyVue', params: {id: option.account.pk}}">
            {{option.account.name}}
          </router-link>
          <span v-else>--</span> -->
          </td>
          <td
            v-if="displaySeller && displayCompany"
            class="is-cell-hoverable">
            <router-link :to="{name: 'UserVue', params: {id: option.user.pk}}">
              {{ option.user.last_name }} {{ option.user.first_name }}
            </router-link>
          </td>
          <td v-else-if="!displayCompany">
            <span>
              {{ option.user.last_name }} {{ option.user.first_name }}
            </span>
          </td>
          <td
            v-if="displayContact && displayCompany && checkContactAccount(index)"
            class="is-cell-hoverable">
            <router-link :to="{name: 'ContactVue', params: {id: option.contact.pk}}">
              {{ option.contact.last_name }} {{ option.contact.first_name }}
            </router-link>
          </td>
          <td
            v-else
            style="cursor: default">
            <span>
              {{ option.contact.last_name }} {{ option.contact.first_name }}
            </span>
          </td>
          <td>
            <span>
              {{ option.created_on | dtFormat('DD/MM/YYYY HH:mm') }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <div
      class="is-padding"
      v-else>
      Aucune option à afficher
    </div>
  </div>
</template>

<script>
import DefaultValues from '@/mixins/DefaultValues.js'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'OptionsLightList',
  mixins: [DefaultValues],
  props: {
    options: {
      type: Array,
      require: true
    }
  },
  data () {
    return {
      tab: 'RUNNING'
    }
  },
  computed: {
    ...mapState(['currentUser']),
    ...mapGetters(['isAdmin', 'isPromoteur']),
    tabList () {
      return [
        { label: `En cours (${this.runningOptions.length})`, link: 'RUNNING' },
        { label: `Historique (${this.pastOptions.length})`, link: 'HISTORY' }
      ]
    },
    currentView () {
      return this.$route.name
    },
    displayCompany () {
      return !this.$route.path.split('/').includes('societes')
    },
    displaySeller () {
      return !this.$route.path.split('/').includes('utilisateurs')
    },
    displayContact () {
      return !this.$route.path.split('/').includes('contacts')
    },
    runningOptions () {
      let okStatus = ['pending', 'approved', 'waiting_list']
      return this.options.filter(x => okStatus.includes(x.status))
    },
    pastOptions () {
      let okStatus = ['refused', 'expired', 'canceled', 'canceled_auto']
      return this.options.filter(x => okStatus.includes(x.status))
    },
    optionsToDisplay () {
      if (this.tab === 'RUNNING') {
        return this.runningOptions
      } else {
        return this.pastOptions
      }
    }
  },
  methods: {
    checkContactAccount (index) {
      const option = this.options[index]
      if (this.currentUser.account.name === option.contact.account.name) return true
      if (this.currentUser.account.name === option.account.name) return true
      return false
    }
  }
}
</script>
